/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabPrescription from './lab-prescription';
import LabPrescriptionDetail from './lab-prescription-detail';
import LabPrescriptionUpdate from './lab-prescription-update';
import LabPrescriptionDeleteDialog from './lab-prescription-delete-dialog';

const LabPrescriptionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabPrescription />} />
    <Route path="new" element={<LabPrescriptionUpdate />} />
    <Route path=":id">
      <Route index element={<LabPrescriptionDetail />} />
      <Route path="edit" element={<LabPrescriptionUpdate />} />
      <Route path="delete" element={<LabPrescriptionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabPrescriptionRoutes;
